import Config from '../config'


var message = _('Please know that if you leave the page now, your changes will be lost');

global.leavePageWarning = function (e) {
  (e || window.event).returnValue = message; //Gecko + IE
  return message; //Gecko + Webkit, Safari, Chrome etc.
}

 //If the environment is production, then display a warning message to customers who tries to leave the page or refesh the page, because otherwise changes would be lost
 if (Config.ShowLeavePageWarning === 'true') {
 	window.addEventListener("beforeunload", global.leavePageWarning);
 }	 
